import React from "react";
import { Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";

function About() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Services | Radix Software Solutions</title>
        <meta name="robots" content="noindex, nofollow" />
        <link
          rel="canonical"
          href="https://www.radixsoftwaresolutions.com/services"
        />
      </Helmet>
      <Navigate to="/services" replace />
    </>
  );
}

export default About;
